import { gql } from '@apollo/client';

export const QUERY_CLOTHING_SIZES = gql`
  query clothingSizes {
    sleeves {
      id
      inch
      inchRounded
      cm
      showInImperialUI
    }
    chestSizes {
      id
      inchRounded
      cm
      showInImperialUI
    }
    necks {
      id
      inch
      inchRounded
      cm
      showInImperialUI
    }
    coats {
      id
      name
    }
    tshirtSizes {
      id
      name
      category {
        code
      }
    }
    waists {
      id
      inchRounded
      cm
      showInImperialUI
    }
    inseams {
      id
      inchRounded
      cm
      showInImperialUI
    }
    gloves {
      id
      inchRounded
      cm
      showInImperialUI
    }
    hatSizes {
      id
      inch
      cm
    }
    shoeSizes {
      id
      sortOrder
      shoeSizeUS
      shoeSizeAU
      shoeSizeUK
      shoeSizeEU
      category {
        id
        code
      }
    }
    shoeModifier {
      id
      name
    }
    dresses {
      id
      sizeUS
      sizeAU
      sizeUK
      sizeEU
    }
    busts {
      id
      inchRounded
      cm
      showInImperialUI
    }
    underBusts {
      id
      inchRounded
      cm
      showInImperialUI
    }
    cupSizes {
      id
      name
    }
    hips {
      id
      inchRounded
      cm
      showInImperialUI
    }
    pants {
      id
      sizeUS
      sizeAU
      sizeUK
      sizeEU
      gender {
        code
      }
    }
    generalSizes {
      id
      name
      category {
        id
        code
      }
    }
  }
`;
